import axiosInstance from "src/common/axiosInstance";

const conversationRuntimeService = {
  async loadUser(workspaceId) {
    const members = [];
    let capabilities = {};
    let page = 1;
    let lastPage = 1;
    do {
      const response = await axiosInstance.get(
        `/workspaces/${workspaceId}/users`,
        {
          params: { assignable: true, status: "Active", per_page: 100, page },
        },
      );
      capabilities = response.data?.capabilities || {};
      members.push(...(response.data?.data || []));
      lastPage = Number(response.data?.meta?.last_page || 1);
      page += 1;
    } while (page <= lastPage);
    return { data: { data: members, capabilities } };
  },

  runtime(conversationId) {
    return axiosInstance.get(
      `/whatsapp-conversations/${conversationId}/runtime`,
    );
  },

  history(conversationId) {
    return axiosInstance.get(
      `/whatsapp-conversations/${conversationId}/runtime/history`,
    );
  },

  conversationHistory(conversationId) {
    return axiosInstance.get(
      `/whatsapp-conversations/${conversationId}/runtime/history/raw`,
    );
  },

  assignUser(conversationId, data) {
    return axiosInstance.post(
      `/whatsapp-conversations/${conversationId}/runtime/actions/assign-user`,
      data,
    );
  },

  assignBot(conversationId, data) {
    return axiosInstance.post(
      `/whatsapp-conversations/${conversationId}/runtime/actions/assign-bot`,
      data,
    );
  },

  changeMode(conversationId, data) {
    return axiosInstance.post(
      `/whatsapp-conversations/${conversationId}/runtime/actions/change-mode`,
      data,
    );
  },

  pause(conversationId, data = {}) {
    return axiosInstance.post(
      `/whatsapp-conversations/${conversationId}/runtime/actions/pause`,
      data,
    );
  },

  resume(conversationId) {
    return axiosInstance.post(
      `/whatsapp-conversations/${conversationId}/runtime/actions/resume`,
    );
  },

  restart(conversationId) {
    return axiosInstance.post(
      `/whatsapp-conversations/${conversationId}/runtime/actions/restart`,
    );
  },

  close(conversationId) {
    return axiosInstance.post(
      `/whatsapp-conversations/${conversationId}/runtime/actions/close`,
    );
  },
};

export default conversationRuntimeService;
